// extracted by mini-css-extract-plugin
export default {"scrollerWrapper":"VirtualScroller_scrollerWrapper","itemWrapper":"VirtualScroller_itemWrapper"};